import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

type UserProfileProps = {
  firstName: string;
  lastName: string;
  displayName: string;
  avatarImage?: string;
  onSelectProfile: () => void;
};

export const UserProfile = ({
  firstName,
  lastName,
  displayName,
  avatarImage,
  onSelectProfile,
}: UserProfileProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="mb-2 text-xs font-inherit text-gray-600 uppercase tracking-wider">
        {t('orgSwitcher.personalProfile')}
      </div>
      <button
        type="button"
        className="flex items-center bg-white text-left rounded font-medium mb-2 p-2 cursor-pointer w-full hover:bg-[rgb(236,243,248)] hover:text-[rgb(29,110,170)] min-h-[56px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        onClick={onSelectProfile}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelectProfile();
          }
        }}
        role="menuitem"
        aria-label={t('orgSwitcher.accessibility.personalProfile', {
          displayName,
        })}
      >
        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white text-sm font-medium mr-3">
          {avatarImage ? (
            <img
              src={avatarImage}
              alt={displayName}
              className="w-full h-full object-cover rounded"
            />
          ) : (
            `${firstName.charAt(0)}${lastName.charAt(0)}`
          )}
        </div>
        <div className="flex-1">
          <div className="text-sm font-medium text-gray-900">{displayName}</div>
        </div>
      </button>
    </>
  );
};
